import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#tree-data-and-lazy-mode" }),
  /*#__PURE__*/_createTextVNode(" Tree data and lazy mode ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%","margin-bottom":"20px"},
          "row-key": "id",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: "date",
              sortable: "",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name",
              sortable: "",
              width: "180"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_table, {
          data: _ctx.tableData1,
          style: {"width":"100%"},
          "row-key": "id",
          border: "",
          lazy: "",
          load: _ctx.load,
          "tree-props": { children: 'children', hasChildren: 'hasChildren' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "date",
              label: "Date",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name",
              width: "180"
            })
          ]),
          _: 1
        }, 8, ["data", "load"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code17), 1)
        ]),
        _: 1
      })
    ])
  ]))
}